import Backbone from 'backbone'
import Parse from 'parse'
import SkyObjectObservation from '../helpers/SkyObjectObservation'
import ObservingSiteModel from './ObservingSite'
import BaseParseObject from './BaseParseObject'

'use strict'

export const ObservingSession = BaseParseObject.extend('ObservingSession', {
  update: function (data) {
    const acl = new Parse.ACL()
    let observingSite

    if (!this.get('ACL')) {
      acl.setPublicReadAccess(false)
      acl.setReadAccess(Parse.User.current().id, true)
      acl.setWriteAccess(Parse.User.current().id, true)

      this.setACL(acl)
    }

    this.set('user', Parse.User.current())
    this.set('name', data.name)
    this.set('startJD', parseFloat(data.startJD))
    this.set('endJD', parseFloat(data.endJD))
    this.set('comments', data.comments)

    if (data.site) {
      // create a class instance when referring to a pointer type in Parse
      observingSite = ObservingSiteModel.createWithoutData(data.site)
      this.set('site', observingSite)
    } else {
      this.unset('site')
    }

    // save the object
    return this.save().then(
      (item) => {
        // The save was successful.
        Backbone.trigger('observingSessions:updated', item)
    },
      (error) => {
            // The save failed.  Error is an instance of Parse.Error.
            Backbone.trigger('errors:parseReturned', error)
        }
    )
  },

  delete: function () {
    const observedCount = SkyObjectObservation.getSkyObjectObservationsByPointerId(this.id, 'session').length
    let message

    if (observedCount > 0) {
      message = `Cannot delete this session because it is still referenced by ${observedCount} observation`
      if (observedCount > 1) {
        message += 's'
      }
      Backbone.trigger('errors:deleteNotAllowed', 'Session', message)
      return Promise.reject(new Error(message))
    }
    // delete the object
    // set the object's `deleted` status to true
    this.set('deleted', true)
    return this.save().then(
      (result) => {
        Backbone.trigger('observingSessions:deleted', result)
      },
      (error) => {
        // The remote operation failed.  Error is an instance of Parse.Error.
        Backbone.trigger('errors:parseReturned', error)
      }
    )
  }

})

export default ObservingSession
